const RESOURCE_BUTTON_KEY = "resource.button-text";
const BLOG_BUTTON_KEY = "blog.button-text";
const THANK_YOU_TITLE = "thank-you.title";

export { RESOURCE_BUTTON_KEY, BLOG_BUTTON_KEY, THANK_YOU_TITLE };
